module.exports = "/_next/static/images/counsellor-314ad95b117a238b03cbc79a3194bd72.png";